import Image from "next/image";
import Marquee from "react-fast-marquee";
import { BASE_ASSETS_URL } from "@constants/constants";

const CustomersMarquee = ({ customersData }) => {
  return (
    <div className="w-full overflow-visible relative h-fit">
      <div className="marquee-container relative overflow-hidden">
        <Marquee
          gradient={false}
          speed={40}
          className=" overflow-hidden p-2 rounded-md"
        >
          {customersData.map((card, idx) => (
            <div
              className="bg-surface text-black rounded-2xl px-11 py-16 mx-2 flex flex-col justify-between h-[520px] w-[390px] border border-surface-dark"
              key={idx}
            >
              {/* Tag */}
              <div className="mb-4">
                <span className="bg-surface-dark rounded-md font-semibold  px-4 py-2 text-gray-700 uppercase ">
                  {card.tag}
                </span>
              </div>

              {/* Logo */}
              <div className="mb-4">
                <div className="inline-flex justify-center items-center p-3 bg-white rounded-xl border border-surface-dark">
                  <Image
                    src={`${BASE_ASSETS_URL}/v2/clm/testimonials/comapnies/${card.logo}`}
                    alt="Company Logo"
                    className="h-auto"
                    width={100}
                    height={100}
                  />
                </div>
              </div>

              {/* Quote */}
              <p className="text-[18px] leading-[26px] text-black font-medium mb-6">
                {card.quote}
              </p>

              {/* Author */}
              <div>
                <p className="font-semibold text-xl">{card.author}</p>
                <p className="text-base text-gray-500">{card.authorTitle}</p>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default CustomersMarquee;
